import React, { useState, useEffect } from 'react';
import Project from '../Project/Project';
import ProjectInProgress from '../ProjectInProgress/ProjectInProgress';
import './Projects.css';

const Projects = () => {
  const [desktop, setDesktop] = useState(true);

  useEffect(() => {
    validDesktop();
  }, []);

  const validDesktop = () => {
    console.log(window.screen.width);
    if (window.screen.width < 1900) {
      setDesktop(false);
    }
  };
  return (
    <div className="projects-container" id="projects">
      <div className="projects-center">
        <hr width="300" />
        <h1>Projects.</h1>
        <div className="projects-rows">
          <a
            target="_blank"
            href="https://challenge-gymnicoala.netlify.app/"
            rel="noreferrer"
          >
            <Project
              title="Gym Page"
              skills="React "
              git="https://github.com/nicoalanis14/Challenge-Gym"
            />
          </a>
          <a
            target="_blank"
            href="https://challenge-phonenicoala.netlify.app/"
            rel="noreferrer"
          >
            <Project
              title="Phone Page"
              skills="React/Bootstrap"
              git="https://github.com/nicoalanis14/Challenge-phone"
            />
          </a>
          <a
            target="_blank"
            href="https://weather-app-6lyysyird-nicoalanis14.vercel.app/"
            rel="noreferrer"
          >
            <Project title="Weather App" skills="React " />
          </a>
          <ProjectInProgress title="Work in Progress" skills="" />
        </div>
        {desktop ? (
          <div className="projects-rows-soon">
            <ProjectInProgress title="Soon" skills="" />
            <ProjectInProgress title="Soon" skills="" />
            <ProjectInProgress title="Soon" skills="" />
            <ProjectInProgress title="Soon" skills="" />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default Projects;
